module.exports = __webpack_public_path__ + "img/heart_small_hover.1132f171.svg";